// export { default } from './api'
export * from './api'
//这里面对应着四个方法 get put post del四个方法

import { http,get,post,put,del} from './api'


const apiServe = {
    // 登录接口函数
    // login是自定义名称，定义login的原因是因为他是登录接口
    // login:(data,method) => http('/login',method,data),


    // 确定好什么方法之后，直接传递参数过来就行，在这边写get post put del 懂了么 
    getIndexData: (data, method) => get('/api/index/index', data),
    getProductData: (data, method) => get('/api/index/product', data),
    getNewlistData: (data, method) => get('/api/index/news?', data),
    getNewDetail: (id, method) => get('/api/index/newsD?' + id),
    getHistoryData: (data, method) => get('/api/index/history',data),
    getHonorsData: (data, method) => get('/api/index/honors',data),
    getCooperationData: (data, method) => get('/api/index/cooperation',data),
    getRecruitmentData: (data, method) => get('/api/index/recruitment',data),
    postMessageData: (data, method) => post('/api/index/message',data),
    postChannelData: (data, method) => get('/api/index/channel',data),
    getCopyWriting: (data, method) => get('/api/index/copywriting',data),
    getQualityData: (data, method) => get('/api/index/quality',data),
    getProductionData: (data, method) => get('/api/index/production',data),
}

export default apiServe